<script setup lang="ts">
defineOptions({
  name: 'UiNotification',
});

defineProps({
  type: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    default: null,
  },
  noIcon: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div :class="['notification', `notification--${type}`]" role="alert">
    <div v-if="!noIcon">
      <i :class="`icon icon--notification-${type} icon--color-signal-${type}`" />
    </div>
    <span :class="['notification__note', { 'notification__note--nospacing': noIcon }]">
      {{ text }}
    </span>
  </div>
</template>

<style lang="scss">
.notification {
  display: flex;
  align-items: center;
  padding: $space30 0;
  animation: moveLeft 0.4s ease forwards;

  h1 + &,
  h2 + & {
    padding-top: 0;
  }
}

.notification__note {
  margin-left: $space10;
  color: var(--color);
}

.notification__note--nospacing {
  margin-left: 0;
}

.notification--no-animation {
  animation: none;
}

.notification--moveup {
  animation: moveUp 0.4s ease forwards;
}

.notification--moveright {
  animation: moveRight 0.4s ease forwards;
}

.notification--movedown {
  animation: moveDown 0.4s ease forwards;
}

.notification--moveleft {
  animation: moveLeft 0.4s ease forwards;
}

.notification--nopadding {
  padding: 0;
}

.notification--hidden {
  display: none;
  padding: 0;
  animation: none;
}

.notification--success {
  --color: #{$signal-success};
}

.notification--alert {
  --color: #{$signal-alert};
}

.notification--note {
  --color: #{$signal-note};
}

.notification--info {
  --color: #{$signal-info};
}

.notification__icon {
  --color: #{$black};
}

.notification__message {
  @include text-style(paragraph);

  color: var(--color);
}

//animations

@keyframes moveRight {
  0% {
    transform: translateX(-$space30);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes moveLeft {
  0% {
    transform: translateX($space30);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes moveUp {
  0% {
    transform: translateY($space30);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes moveDown {
  0% {
    transform: translateY(-$space30);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
